import { httpRequest } from "../../../utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";
import { IItemDetailList, IMaterialDetailList, IMaintenanceList, ItemDetailed, MaterialDetailed, IMaintenanceSettle, IMaintenanceField, IMaintenanceSearch, IMaintenanceDetail, IMaintenanceRoSettleAndWhConfirm, chargebackApprovalAndPass } from "./maintenanceTypes"
class MaintenanceService {
    async page(searchVo: IMaintenanceSearch) {
        const apiUrl = "/vrm-sa/maintenance/findPage";
        return await httpRequest.post<IMaintenanceList>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/maintenance/findById/${id}`;
        return await httpRequest.get<IMaintenanceDetail>(apiUrl);
    }

    async insert(insertVo: IMaintenanceField) {
        const apiUrl = "/vrm-sa/maintenance/insert";
        return await httpRequest.post<IMaintenanceDetail>(apiUrl, insertVo);
    }
    async update(updateVo: IMaintenanceField) {
        const apiUrl = "/vrm-sa/maintenance/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    // 库房确认
    async warehousing(params: IMaintenanceRoSettleAndWhConfirm) {
        const apiUrl = "/vrm-sa/maintenance/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //维修用料明细删除
    async materialDelete(params: MaterialDetailed) {
        const apiUrl = "/vrm-sa/maintenance/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //维修项目明细删除
    async itemDelete(params: ItemDetailed) {
        const apiUrl = "/vrm-sa/maintenance/itemDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //结算
    async settl(params: IMaintenanceSettle) {
        const apiUrl = "/vrm-sa/maintenance/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //作废
    async invalidate(params: object) {
        const apiUrl = "/vrm-sa/maintenance/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //重新加载维修项目得数据
    async projectQuery(params: string[]) {
        const apiUrl = "/vrm-sa/base/item/projectQuery";
        return await httpRequest.post<ItemDetailed[]>(apiUrl, params);
    }
    //重新加载维修用料得数据
    async find(params: string[]) {
        const apiUrl = "/vrm-sa/stock/find";
        return await httpRequest.post<MaterialDetailed[]>(apiUrl, params);
    }
    //打印
    async printing(params: object) {
        const apiUrl = "/vrm-sa/maintenance/printing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //工单批量导出
    async export(params: IMaintenanceSearch) {
        const apiUrl = "/vrm-sa/maintenance/All/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 600000 });
    }
    //工单详情导出
    async detailsExport(params: object) {
        const apiUrl = "/vrm-sa/maintenance/detailsExport";
        return await httpRequest.postFile(apiUrl, params, { timeout: 600000 });
    }
    //工单退单待审
    async chargebackApproval(params: chargebackApprovalAndPass) {
        const apiUrl = "/vrm-sa/maintenance/chargebackApproval";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //工单退单审核
    async chargebackPassed(params: chargebackApprovalAndPass) {
        const apiUrl = "/vrm-sa/maintenance/chargebackPassed";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
}
export const maintenanceService = new MaintenanceService();
